import "./check-mark.scss";

import classNames from "classnames";
import { FunctionComponent } from "react";

import { ReactComponent as CheckIconWhite } from "@client/components/reusable/SvgIcons/library/check_icon_white.svg";

import SvgIcon from "../SvgIcons";

interface CheckMarkProps {
	className?: string;
	selected?: boolean;
	onClick?: () => void;
}

export const CheckMark: FunctionComponent<CheckMarkProps> = ({
	selected,
	onClick,
}) => {
	return (
		<div className={classNames("check-mark", { selected })} onClick={onClick}>
			{selected && (
				<SvgIcon component={CheckIconWhite} width="14" height="14" />
			)}
		</div>
	);
};
